import axios from "axios";
import { getAuthToken, clearAuthData } from "../utils/storage";
import { sanitizeApiErrorPayload } from "../utils/apiErrors";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

if (process.env.NODE_ENV === "development") {
  console.log("API BASE URL:", process.env.REACT_APP_API_BASE_URL);
}

// REQUEST INTERCEPTOR
const PUBLIC_AUTH_PATHS = ["/auth/admin/login"];

api.interceptors.request.use(
  (config) => {
    const isPublicAuth = PUBLIC_AUTH_PATHS.some((path) =>
      config.url?.includes(path)
    );

    if (isPublicAuth) {
      return config;
    }

    const token = getAuthToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// RESPONSE INTERCEPTOR
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;
    const isLoginRequest = error.config?.url?.includes("/auth/admin/login");

    switch (status) {
      case 401: {
        // Don't wipe credentials mid-login attempt for wrong password
        if (!isLoginRequest) {
          clearAuthData();
          if (window.location.pathname !== "/login") {
            window.location.replace("/login");
          }
        }
        break;
      }

      case 500:
        console.error("Server error occurred");
        break;

      default:
        break;
    }

    const payload = sanitizeApiErrorPayload(
      error.response?.data || { message: error.message },
      status
    );

    return Promise.reject(payload);
  }
);

export default api;
